import axios from 'axios'

export const upload = async (productId, file, url, altAttribute, priority) => {
  const formData = new FormData()
  formData.append('product_image[product_id]', productId)
  formData.append('product_image[alt_attribute]', altAttribute)
  formData.append('product_image[priority]', priority)
  if (url) {
    formData.append('product_image[url]', url)
    formData.append('product_image[image_type]', 'url')
  } else {
    formData.append('product_image[file]', file)
    formData.append('product_image[image_type]', 'file')
  }

  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  return new Promise((resolve, reject) =>
    axios
      .post('/api/product_images', formData, config)
      .then(function () {
        resolve()
      })
      .catch(function (error) {
        reject(error)
      })
  )
}

export const update = (imageId, altAttribute, priority) => {
  return axios.patch(`/api/product_images/${imageId}`, {
    productImage: { altAttribute: altAttribute, priority: priority }
  })
}

export const _delete = (imageId) => {
  return axios.delete(`/api/product_images/${imageId}`)
}
